var map = {
	"./airoplane 1.jpg": 59679,
	"./android 1.jpg": 8509,
	"./android.jpg": 52440,
	"./apple logo.jpg": 45900,
	"./chat gpt.jpg": 36740,
	"./chrome.jpg": 90607,
	"./fb.jpg": 88593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61855;